import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IGetSpaceAllPlacesResponseApi } from "@interfaces/IGetSpaceAllPlacesResponseApi.ts"
import { IGetSpaceAllPlacesResponseCli } from "@interfaces/IGetSpaceAllPlacesResponseCli.ts"

export const GetSpaceAllPlacesAdapter = (
	response: IApiResponse<IGetSpaceAllPlacesResponseApi>
): IGetSpaceAllPlacesResponseCli => {
	return response.data
}
